import { HierarchyAction, ActionTypes } from './actions';
import { HierarchyStateFactory, HierarchyEntitiesRecordFactory, HierarchyTreeStateFactory } from './factories';

const initialState = HierarchyStateFactory({
  selectedEntity: window.history.state?.state?.hierarchyEntity,
});

function hierarchyReducer(state = initialState, action: HierarchyAction) {
  switch (action.type) {
    case ActionTypes.START_HIERARCHY_LOADING:
      return state.setIn(['hierarchy', 'loading'], true);
    case ActionTypes.GET_HIERARCHY_SUCCESS:
      return state.set(
        'hierarchy',
        HierarchyTreeStateFactory({
          loading: false,
          values: HierarchyEntitiesRecordFactory(action.payload.hierarchy),
        })
      );

    case ActionTypes.GET_HIERARCHY_FAIL:
      return state.setIn(['hierarchy', 'loading'], false);

    case ActionTypes.SET_SELECTED_ENTITY:
      return state.setIn(['selectedEntity'], action.payload.scope);
    default:
      return state;
  }
}

export default hierarchyReducer;
